import React, { useEffect } from "react";

enum EVERSION {
    BLACK = 'black',
    NORMAL = 'norm'
}

const BLACK_VERSION = 'version-bl';

/*BLACK-VERSION*/
const BlackVersionButton: React.FC = () => {
    const body: HTMLBodyElement | null = document.querySelector('body');

    useEffect(() => {
        if (body && sessionStorage.getItem('blackVersion') === EVERSION.BLACK) {
            body.classList.add(BLACK_VERSION);
        }
    });

    const switchVersionHandler = () => {
        if (body) {
            body.classList.toggle(BLACK_VERSION);
            sessionStorage.setItem('blackVersion', body.classList.contains(BLACK_VERSION) ? EVERSION.BLACK : EVERSION.NORMAL);
        }
    }

    return (
        <div className="header__sv">
            <span
                className="header__sv__btn"
                onClick={switchVersionHandler}
            ></span>
        </div>
    );
}

export default BlackVersionButton;